import React, { useMemo, useState } from 'react'
import { useGlobalFilter, usePagination, HeaderGroup, Accessor, useSortBy, useTable } from 'react-table'
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import ButtonDownloadReportTable from "components/Varios/Tabla/ComponentButtonExcel"
import { Container, Row, Col, Button } from 'react-bootstrap';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { Table } from 'reactstrap'
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import config from "config.json";
import { CustomStyleColumn } from 'components/Types/GeneralTypes';

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import AnularSVG from "assets/icons/Permisos/anularXazul.svg"
import AprobarSVG from "assets/icons/Permisos/Visto.svg"
import RechazoPSVG from "assets/icons/Permisos/Regresar.svg"


export default function TablaHistorialAprobacionesPermisosDoc({ dataFilas, onClickVerDocumento, anioSeleccionado, onChangeAnio }) {
    
  const [anioMostrado, setanioMostrado] = useState(anioSeleccionado);

  function GenerarCellDocumentos(data) {
        const iconoDescargarEvidencia = (
            <i
                data-toggle="tooltip" data-placement="top" title="Vista Previa Evidencia"
                onClick={() => onClickVerDocumento(data.documentos.evidencia)}
            >
                <img
                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Vista Previa Evidencia"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Vista Previa Evidencia"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const iconoDescargarSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Vista Previa Solicitud"
                onClick={() => onClickVerDocumento(data.documentos.documento)}
            >
                <img
                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Vista Previa Solicitud"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Vista Previa Solicitud"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )


        const contentAccion = (
            <React.Fragment>
                {data.documentos.evidencia && iconoDescargarEvidencia}
                {data.documentos.documento && iconoDescargarSolicitud}

            </React.Fragment>
        )
        return contentAccion
    }


  const filas = useMemo(
    () => [...dataFilas], [dataFilas]
  )

  const columnas: any = React.useMemo(
    () => [
        {
            Header: 'Fecha Solicitud',
            accessor: 'fechaSolicitud',
            Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
        },
        {
        
            Header: 'Tipo Solicitud',
            accessor: 'tipo',
        },
        
        {
            Header: 'Identificación',
            accessor: 'identificacion', // accessor is the "key" in the data
        },
        {
            Header: 'Nombre de servidor',
            accessor: 'nombres',
        },


        {
            Header: 'Aprobado por',
            accessor: 'nombreAutoridadAprobo',
        },
        {
            Header: 'Fecha desde',
            accessor: 'fechaDesde',
            Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined

        },
        {
            Header: 'Fecha hasta',
            accessor: 'fechaHasta',
            Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined

        },
        {
            Header: 'Días',
            accessor: 'diasOrdinarios',
        },

        {
            Header: 'Estado',
            accessor: 'estado',
        },
      {
        Header: "Documentos",
        accessor: (row) => ({
            documentos: row,
        }),
        Cell: ({ value }) => GenerarCellDocumentos(value)
      },

    ], [dataFilas]
  )

    const columnasStyles = (cell): Array<CustomStyleColumn> => [
    {
      HeaderName: 'Fecha Solicitud',
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: 'Tipo Solicitud',
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: 'Fecha Desde',
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: 'Fecha Hasta',
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: 'Días',
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: 'Horas',
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: 'Documentos',
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: 'Acciones',
      StyleHeader: {
        textAlign: "center"
      }
    },
  ]

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    visibleColumns,
    prepareRow,
    state,
    setGlobalFilter
  } = useTable(
    {
      columns: columnas,
      data: filas
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { globalFilter, pageIndex, pageSize } = state;
  const sizerows = filas.length;


  function HandleChangeAnioOnTable(anioSeleccionado) {
    if (typeof (anioSeleccionado) === "number") {
      setanioMostrado(anioSeleccionado.toString())
    }
    onChangeAnio(anioSeleccionado)
  }

  const BotonDescargarReporte = useMemo(() => {

    const URLAnios = "AprobacionTh/HistorialSolicitudes/AniosDisponibles";

    const URLREPORTE = "AprobacionTh/HistorialSolicitudes/Reporte"



    if (anioSeleccionado !== undefined) {

      const anioForButton = +anioSeleccionado

      return (
        <ButtonDownloadReportTable
          api={URLREPORTE}
          nombreBoton='Reporte Historial Licencias'
          apiYears={URLAnios}
          onChangeYearNotAsync={HandleChangeAnioOnTable}
          yearElegido={anioForButton}
        />
      )
    }

  }, [anioSeleccionado])


  return (
    <React.Fragment>
      <Row>
        <Col xl={12}>
          <GlobalFilterTable
            filter={globalFilter}
            setFilter={setGlobalFilter}
          />
        </Col>
      </Row>
      <Row className="justify-content-end mb-1">
        <Col xl={3} lg={3} md={4} sm={12}>
          {BotonDescargarReporte}
        </Col>
      </Row>
      <Row>
        <Col xl={12}>
          <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
            <thead style={{}}>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className='clickable'
                    >
                      {column.render('Header')}
                      <span>
                        {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, indirow) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()}>

                    {row.cells.map(cell => {
                        return getTdTableStyles(cell, { border: 'solid 1px black' }, indirow, columnasStyles(cell))

                    })}
                  </tr>
                )
              })}
            </tbody>
          </Table>
          <ComponentePaginacionTabla
            page={page}
            sizerows={sizerows}
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            nextPage={nextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            previousPage={previousPage}
            setPageSize={setPageSize}

          />
        </Col>
      </Row>



    </React.Fragment>
  )
}